module.exports = __webpack_public_path__ + "media/frames/frame_black_horizontal-0a163293.jpg";